import { useCallback } from "react";
import { isEmpty } from "@swiggy-private/js-utils";
import { NavigationTypes } from "@swiggy-private/native-bridge";
import { useRouter } from "next/compat/router";
import { BillPaymentActionType, IBillPaymentResponse } from "./useBillPayment";
import { getBridgeSdk } from "../utils/bridgeSdk";
import { isApp } from "../utils/browser";

export const useBillPaymentAction = () => {
    const router = useRouter();

    const handleBillPaymentAction = useCallback(
        (result: IBillPaymentResponse, setBillPaymentData: (data: IBillPaymentResponse) => void): void => {
            switch (result.actionType) {
                case BillPaymentActionType.REDIRECT: {
                    // Backend always sends a single CTA for REDIRECT action type.
                    // Directly navigate to ctas[0] — confirmed with Product and Backend team.
                    const cta = result.ctas?.[0];
                    if (!isEmpty(cta)) {
                        if (cta.type === NavigationTypes.DEEPLINK && isApp()) {
                            getBridgeSdk()
                                .navigateToScreen({
                                    type: NavigationTypes.DEEPLINK,
                                    link: cta.link,
                                })
                                .catch(console.error);
                        } else {
                            router?.push(cta.link);
                        }
                    }
                    break;
                }
                case BillPaymentActionType.HALF_CARD:
                default:
                    setBillPaymentData(result);
                    break;
            }
        },
        [router],
    );

    return { handleBillPaymentAction };
};
